<mat-toolbar class="border-bottom ">
    <button data-test="botao-abrir-menu" *ngIf="isLogged" mat-icon-button class="no-padding hamburger-button" (click)="clickedMenu()" id="hamburgerButton">
        <i class="material-icons" *ngIf="!showCloseButton">menu</i>
        <i class="material-icons" *ngIf="showCloseButton && !isDesktop">close</i>
        <i class="material-icons" *ngIf="showCloseButton && isDesktop">arrow_back</i>
    </button>
    <div class="logo">
        <img [src]="logoUrl" [alt]="appName">
    </div>
    <div class="separar-itens config">
        <div *ngIf="isLogged" class="header-items">
            <div *ngIf="statusId === 1 && trialDaysLeft !== null && trialDaysLeft > 0 && isDesktop" class="trial-period" >
                <span (click)="onClickTrialPeriod()"> {{ "trial-days.trial-message-desktop" | translate }} {{ trialDateEnds }}{{ "trial-days.trial-message-enjoy" | translate }}</span>
            </div>
            <div *ngIf="statusId === 1 && trialDaysLeft !== null && trialDaysLeft > 0 && !isDesktop" class="trial-period" >
                <span (click)="onClickTrialPeriod()"> {{ "trial-days.trial-message-mobile" | translate }} {{ trialDaysLeft }} </span>
            </div>
            <div *ngIf="statusId === 2" class="trial-period" >
                <span (click)="onClickTrialPeriod()"> Pagamento Pendente </span>
            </div>
            <button id="chatAssistant" mat-button (click)="clickedAssistant()">
                <i class="material-icons-outlined">try</i> {{ "assistant.assistant" | translate }}
            </button>
            <button data-test="btn-configurações" id="accountConfigurations" mat-icon-button class="no-padding" routerLink="configuration">
                <i class="material-icons">settings_suggest</i>
            </button>
            <!-- <button mat-icon-button class="no-padding">
                <i class="material-icons">circle_notifications</i>
            </button> -->
            <div class="divider margin-between" *ngIf="isDesktop"></div>
            <span class="welcome-text margin-between" *ngIf="isDesktop">
                {{ 'hello' | translate }}, <span class="uppercase-first-letter">{{nameUser}}</span>
            </span>
        </div>
    </div>
</mat-toolbar>

<ng-template #TrialPeriodWarningDialog let-data>
    <app-trial-warning-dialog></app-trial-warning-dialog>
</ng-template>

<ng-template #dialogTemplate>
    <app-chatbase></app-chatbase>
</ng-template>

<ng-template #dialogTemplate>
    <app-chatbase></app-chatbase>
</ng-template>
